import { Grid, Typography } from "@mui/material";
import Dropzone from "react-dropzone";
import { IEditStatusEmailValues, IUploadImage } from "../../interfaces/order";

interface IUploadImageOverlayProps {
  width: number;
  height: number;
}

const UploadImageOverlay = ({ width, height }: IUploadImageOverlayProps) => (
  <Grid
    container
    display="flex"
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
    position="absolute"
    top="0"
    left="0"
    height="100%"
    className="upload-image-overlay"
  >
    <div style={{ zIndex: "2", textAlign: "center", cursor: "pointer" }}>
      <span className="material-symbols-rounded f-s-36 text-white">
        add_photo_alternate
      </span>
      <Typography className="text-white f-s-14">
        {width} x {height} px
      </Typography>
    </div>
  </Grid>
);

const UploadImage = ({
  imagePreview,
  imageFromTemplate,
  maxWidth,
  id,
  width,
  height,
  fullWidth,
  setValues,
  handleUpload,
}: IUploadImage) => (
  <Dropzone
    accept={{
      "image/png": [".png"],
      "image/jpeg": [".jpg", ".jpeg"],
      "image/webp": [".webp"],
    }}
    onDrop={(acceptedFiles) => {
      setValues((current: IEditStatusEmailValues) => ({
        ...current,
        [id]: acceptedFiles[0],
      }));
      handleUpload(id, acceptedFiles[0]);
    }}
  >
    {({ getRootProps, getInputProps }) => (
      <div {...getRootProps()} style={{ position: "relative", maxWidth }}>
        <input {...getInputProps()} />
        <img
          src={imagePreview || imageFromTemplate}
          alt={id}
          width={fullWidth ? "100%" : width}
          height={fullWidth ? "auto" : height}
          className="br-5"
          style={{ display: "block" }}
        />
        <UploadImageOverlay width={width} height={height} />
      </div>
    )}
  </Dropzone>
);

export default UploadImage;
